import React, { memo, useMemo } from 'react';
import { Line } from 'react-chartjs-2';

const ClickableLineChart = memo(({ data, options, onClick, height = 'h-64', tooltipLabel = 'Click to view details' }) => {
  const chartOptions = useMemo(() => ({
    ...options,
    onClick,
    plugins: {
      ...options.plugins,
      tooltip: {
        ...options.plugins?.tooltip,
        callbacks: {
          afterLabel: () => tooltipLabel
        }
      }
    }
  }), [options, onClick, tooltipLabel]);

  if (!data) return null;

  return (
    <div className={height}>
      <Line data={data} options={chartOptions} />
    </div>
  );
});

export default ClickableLineChart;
